import { useMemo } from "react";

export const useBlogSchema = ({
  headline,
  datePublished,
  dateModified,
  image,
  authorName,

}: {
  headline: string;
  datePublished: string;
  dateModified: string;
  image?: string;
  authorName?: string;
}) => {
  return useMemo(() => {
    if (!headline || !datePublished || !dateModified) return null;

    return {
      "@context": "https://schema.org",
      "@type": "NewsArticle",
      "headline": headline,
      "datePublished": new Date(datePublished).toISOString(),
      "dateModified": new Date(dateModified).toISOString(),
      ...(image && { "image": image }),
      ...(authorName && {
        "author": {
          "@type": "Person",
          "name": authorName
        }
      })
    };
  }, [headline, datePublished, dateModified, image, authorName]);
    };
